import React from "react";

import { Button, Icon } from "../../../components/common";
import {
  BoxSummary,
  Div,
  DivBox,
  DivIcon,
  EditButton,
  FlexCol,
  Footer,
  H2,
  ReplicateSubtitleSummary,
  ReplicateTitle,
} from "../style";

const StepSummary = ({
  handleChange,
  valueReplicate,
  valueDestiny,
  optionSelected,
  handlePostReplicate,
}) => {
  return (
    <>
      <H2>Resumo</H2>
      <p>
        Antes de concluir, confira os detalhes pois você não poderá cancelar
        essa ação.
      </p>
      <FlexCol>
        <BoxSummary>
          <Icon
            width={"56px"}
            height={"56px"}
            name={"replicateMenu"}
            stroke={"primary"}
          />
          <DivBox>
            <ReplicateTitle>
              {valueReplicate === "replicate" ? "Cardápio Completo" : "Produto"}
            </ReplicateTitle>
            <ReplicateSubtitleSummary>
              {valueReplicate === "replicate"
                ? "Replicar todas as categorias e produtos."
                : "Replicar apenas um produto específico."}
            </ReplicateSubtitleSummary>
          </DivBox>
          <Div>
            <EditButton onClick={() => handleChange("origin")}>
              <Icon
                width={"16px"}
                height={"16px"}
                name={"replicateEdit"}
                stroke={"red"}
              />
              editar
            </EditButton>
          </Div>
        </BoxSummary>
        <DivIcon>
          <Icon
            width={"30px"}
            height={"30px"}
            name={"replicateArrowDown"}
            stroke={"#119C4A"}
          />
        </DivIcon>
        <BoxSummary>
          <Icon
            width={"56px"}
            height={"56px"}
            name={"replicateStoreSearch"}
            stroke={"primary"}
          />
          <DivBox>
            <ReplicateTitle>
              {valueDestiny === "all_units"
                ? "Todas as Unidades"
                : "Unidades específicas"}
            </ReplicateTitle>
            <ReplicateSubtitleSummary>
              {valueDestiny === "all_units"
                ? "Todas as unidades receberão a réplica."
                : optionSelected &&
                  optionSelected.length > 0 &&
                  optionSelected.map((store) => {
                    return ` ${store.label} /`;
                  })}
            </ReplicateSubtitleSummary>
          </DivBox>
          <Div>
            <EditButton onClick={() => handleChange("destiny")}>
              <Icon
                width={"16px"}
                height={"16px"}
                name={"replicateEdit"}
                stroke={"red"}
              />
              editar
            </EditButton>
          </Div>
        </BoxSummary>
      </FlexCol>
      <Footer>
        <Button
          className="default-error"
          width={"80px"}
          onClick={() => handleChange("destiny")}
        >
          Cancelar
        </Button>
        <Button
          className="success"
          width={"80px"}
          onClick={() => handlePostReplicate()}
        >
          Continuar
        </Button>
      </Footer>
    </>
  );
};

export default StepSummary;
